import { DisplayMode } from '@amzn/ihm-floorplan-core';

export interface DisplayModeOptions {
  optionsList: DisplayMode[];
  defaultOption: DisplayMode;
}

export const zoneColors: Record<string, string> = {
  Banana: '#f4d03f',
  Melons: '#e5c466',
  Tropical: '#c1ee00',
  'Potatoes & Yams': '#6a3d09',
  Garlic: '#f6faf3',
  Onions: '#bb8fce',
  Pears: '#d5f3cf',
  Apples: '#e74c3c',
  Citrus: '#f39c12',
  Tomato: '#c0392b',
  Avocados: '#196f3d',
  Squash: '#b6a42b',
  Vegetables: '#3b9a0f',
  Fruit: '#a572a2',
  Herb: '#5b7b0f',
  Yams: '#9b7b0f',
  'Stone Fruit': '#d284a2',
};

export const defaultFillColor = '#CCCCCC';

export const defaultZoneFillColor = '#e7c2aa';
